import { useSyncExternalStore } from "react";
import {
  getPwaInstallSnapshot,
  subscribePwaInstall,
} from "../utils/pwaInstallPrompt";

// Reads the shared beforeinstallprompt capture (see utils/pwaInstallPrompt)
// so any component gets the already-captured event even if it mounts after
// a client-side route change, not just the one that happened to be mounted
// when the browser fired it.
export const usePwaInstallPrompt = () =>
  useSyncExternalStore(subscribePwaInstall, getPwaInstallSnapshot);
